module.exports = __webpack_public_path__ + "img/901122935.15c0da77.png";